<template>
    <div id="imageModal" class="modal">
        <div class="modal-overlay" @click="closeModal()"></div>
        <div class="modal-content">
            <span class="close-btn" @click="closeModal()">&times;</span>
            <img id="modalImage" class="modal-image" :src="alertImage" ref="image">
             <span 
                :style="{
                    fontSize: getAlertFontSize,
                    color: 'white',
                    fontWeight: 'bold',
                    width: spanSize.width,
                    height: spanSize.height
                }" 
                style="
                    position: absolute;
                    display: flex;
                    align-items: start;
                    justify-content: center;
                    text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
                    word-wrap: break-word;
                    overflow: auto;
                "
                >
                {{ text }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
  name: 'info-alert',
  props: {
    value: {type: Boolean},
    text: {type: String, default: "Aviso informativo"},
    alertType: {type: String, default: ''},
    alertFontSize: {type: String, default: 'S'},
    alertImage: {type: String, default: ''},
  },
  data: () => ({
    spanSize: {
        height: 0,
        width: 0
    },
    resizeObserver: null
  }),
  computed: {
    infoAlertState: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    getAlertFontSize() {
      switch (this.alertFontSize) {
        case 'XS':
          return '0.75rem'
        case 'S':
          return '1rem'
        case 'M':
          return '1.25rem'
        case 'L':
          return '1.5rem'
        case 'XL':
          return '1.75rem'
        case 'XXL':
          return '2rem'
        default:
          return '1rem'
      }
    },
    alertTypeText() {
      switch (this.alertType) {
        case 'white':
          return 'black--text'
        case 'black':
          return 'white--text'
        case 'error':
          return 'white--text'
        case 'warning':
          return 'white--text'
        case'success':
          return 'white--text'
        case'info':
          return 'white--text'
        default:
          return 'black--text'
      }

    }
  },
  mounted() {
    this.openModal(this.alertImage)
    this.observeImageSize()
  },
  beforeDestroy(){
    if(this.resizeObserver){
        this.resizeObserver.disconnect()
    }
  },
  methods: {
    openModal(imageSrc) {
        const modal = document.getElementById('imageModal');
        const modalImage = document.getElementById('modalImage');
        
        modalImage.src = imageSrc;
        modal.classList.add('active');
        
        // Prevenir scroll del body cuando el modal está abierto
        document.body.style.overflow = 'hidden';
    },
    closeModal() {
        const modal = document.getElementById('imageModal');
        modal.classList.remove('active');
        
        // Restaurar scroll del body
        document.body.style.overflow = 'auto';
    },
    observeImageSize(){
        if(!this.$refs.image) return

        const updateSpanSize = () => {
            const img = this.$refs.image
            if(img) {
                this.spanSize.width = img.offsetWidth + 'px'
                this.spanSize.height = img.offsetHeight + 'px'
            }
        }

        this.resizeObserver = new ResizeObserver(updateSpanSize)
        this.resizeObserver.observe(this.$refs.image)
        this.$nextTick(updateSpanSize)
    }
  },
}
</script>

<style>

    /* MODAL STYLES */
    .modal {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.9);
        z-index: 1000;
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    .modal.active {
        display: flex;
        opacity: 1;
    }

    .modal-content {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }

    .modal-image {
        max-width: 95%;
        max-height: 95%;
        width: auto;
        height: auto;
        object-fit: cover;
        border-radius: 8px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    }

    /* Botón de cerrar */
    .close-btn {
        position: absolute;
        top: 20px;
        right: 30px;
        color: white;
        font-size: 40px;
        font-weight: bold;
        cursor: pointer;
        z-index: 1001;
        transition: color 0.3s ease;
        background: rgba(0, 0, 0, 0.5);
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
    }

    .close-btn:hover {
        color: #ff6b6b;
        background: rgba(0, 0, 0, 0.7);
    }

    /* Responsive para pantallas pequeñas */
    @media (max-width: 768px) {
        .modal-content {
            padding: 10px;
        }
        
        .modal-image {
            max-width: 98%;
            max-height: 98%;
        }
        
        .close-btn {
            top: 10px;
            right: 15px;
            font-size: 30px;
            width: 40px;
            height: 40px;
        }
    }

    /* Para pantallas muy pequeñas */
    @media (max-width: 480px) {
        
        .modal-content {
            padding: 5px;
        }
        
        .modal-image {
            max-width: 100%;
            max-height: 100%;
            border-radius: 0;
        }
    }

    /* Animación de entrada */
    @keyframes modalFadeIn {
        from {
            opacity: 0;
            transform: scale(0.8);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    .modal.active .modal-image {
        animation: modalFadeIn 0.3s ease;
    }

    /* Estilos adicionales para mejor UX */
    .modal-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
    }

    /* Indicador de carga */
    .loading {
        color: white;
        font-size: 18px;
        text-align: center;
    }
</style>